const IS_DEV_ENV = process.env.NODE_ENV === 'development';
const IS_PROD_ENV = process.env.NODE_ENV === 'production';
const PUBLIC_BASE_URL_ENV = process.env.NEXT_PUBLIC_BASE_URL || '';
const PUBLIC_API_URL_ENV = process.env.NEXT_PUBLIC_API || '';
const PUBLIC_GTM_ID_ENV = process.env.NEXT_PUBLIC_GTM_ID || '';
const PUBLIC_LOGIN_URL_ENV = process.env.NEXT_PUBLIC_LOGIN_URL || '';
const PUBLIC_REGISTER_URL_ENV = process.env.NEXT_PUBLIC_REGISTER_URL || '';
const PUBLIC_CORE_APP_URL_ENV = process.env.NEXT_PUBLIC_CORE_APP_URL;
const PUBLIC_CSS_VERSION = process.env.NEXT_PUBLIC_CSS_VERSION || '';
const PUBLIC_ADDRESS_API_URL_ENV = process.env.NEXT_PUBLIC_ADDRESS_API_URL || '';
const PUBLIC_ADDRESS_API_KEY_ENV = process.env.NEXT_PUBLIC_ADDRESS_API_KEY || '';
const PUBLIC_TARGET_CONFIGURATION = process.env.NEXT_PUBLIC_TASK_TARGET_CONFIGURATION || '';
const GET_ADDRESS_API_URL_ENV = process.env.NEXT_PUBLIC_GET_ADDRESS_API_URL || '';
const GET_ADDRESS_API_KEY_ENV = process.env.NEXT_PUBLIC_GET_ADDRESS_API_KEY || '';
const PUBLIC_APP_INSIGHTS_KEY_ENV = process.env.NEXT_PUBLIC_APPINSIGHTS_KEY || '';
const PUBLIC_UPDATE_DETAILS_URL_ENV = process.env.NEXT_PUBLIC_UPDATE_DETAILS_URL || '';

const PRIVATE_FREEFORM_API_URL_ENV = process.env.NEXT_PRIVATE_FREEFORM_API_URL || '';
const PRIVATE_FREEFORM_API_KEY_ENV = process.env.NEXT_PRIVATE_FREEFORM_API_KEY || '';
const PRIVATE_FREEFORM_API_VERSION_ENV = process.env.NEXT_PRIVATE_FREEFORM_API_VERSION || '';

const PUBLIC_IDM_API_URL_ENV = process.env.NEXT_PUBLIC_IDM_API_URL || '';
const PUBLIC_I18N_URL_ENV = process.env.NEXT_PUBLIC_I18N_URL || '';
const PUBLIC_CHANNEL = process.env.NEXT_PUBLIC_CHANNEL || '';

export {
	IS_DEV_ENV,
	IS_PROD_ENV,
	PUBLIC_API_URL_ENV,
	PUBLIC_BASE_URL_ENV,
	PUBLIC_CORE_APP_URL_ENV,
	PUBLIC_CSS_VERSION,
	PUBLIC_GTM_ID_ENV,
	PUBLIC_LOGIN_URL_ENV,
	PUBLIC_REGISTER_URL_ENV,
	PUBLIC_ADDRESS_API_URL_ENV,
	PUBLIC_ADDRESS_API_KEY_ENV,
	PUBLIC_TARGET_CONFIGURATION,
	PUBLIC_APP_INSIGHTS_KEY_ENV,
	PUBLIC_UPDATE_DETAILS_URL_ENV,
	GET_ADDRESS_API_URL_ENV,
	GET_ADDRESS_API_KEY_ENV,
	PRIVATE_FREEFORM_API_URL_ENV,
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_IDM_API_URL_ENV,
	PUBLIC_I18N_URL_ENV,
	PUBLIC_CHANNEL
}